import React from "react";
import useNetwork from "../../Hooks/useNetwork";
import ProfileSection from "../../sections/Profile/ProfileSection/ProfileSection";
import WalletNotConnected from "../../components/WalletNotConnected/WalletNotConnected";
import ProfileCollectionNfts from "../../components/ProfileCollectionNfts/ProfileCollectionNfts";

const ProfilePage = () => {
  const { isConnected, validChain } = useNetwork();

  return (
    <>
      {isConnected && validChain ? (
        <div className="flex flex-col gap-5">
          <ProfileSection />
          <ProfileCollectionNfts />
        </div>
      ) : (
        <WalletNotConnected />
      )}
    </>
  );
};

export default ProfilePage;
